module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services05-c6ef2787e2df8c992cd353f85502e1f7.jpg";